import { render, staticRenderFns } from "./yearly.vue?vue&type=template&id=5342853e&"
import script from "./yearly.vue?vue&type=script&lang=js&"
export * from "./yearly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports